<template>
  <div
    class="d-flex flex-column min-vh-100 vh-100"
    data-spy="scroll"
    data-target="#mainNav"
    data-offset="75"
  >
    <navigation-main />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-8">
                  <h2 class="text-black mt-0">Available packages</h2>
                  <hr class="divider-full-width dark " />

                  <div class="list-group text-left">
                    <div
                      class="list-group-item  list-group-item-action  flex-column align-items-start"
                      style="border-top: 1px solid lightgray"
                      v-for="pack in getAvailablePackages()"
                      :key="pack.packageId"
                    >
                      <div class="row no-gutters">
                        <div class="col-auto">
                          <img
                            :src="'/thumbnails/' + pack.packageId + '.png'"
                            class="img-fluid"
                            style="height:100px"
                            alt=""
                          />
                        </div>
                        <div class="col">
                          <div class=" px-2">
                            <div class="d-flex w-100 justify-content-between">
                              <h5 class="mb-1 ">
                                <a
                                  :href="pack.downloadTitle"
                                  @click.prevent="
                                    downloadDataset(
                                      pack.packageId,
                                      pack.downloadTitle
                                    )
                                  "
                                  class=""
                                  style="color:green"
                                  >{{ pack.downloadTitle }}</a
                                >
                              </h5>
                              <small class="text-muted"
                                >{{ pack.size }}

                                <a
                                  href="javascript:void(0)"
                                  @click="loadMD5(pack.packageId)"
                                  v-if="!checksums[pack.packageId]"
                                  >[MD5]</a
                                >
                                <a
                                  href="javascript:void(0)"
                                  @click="removeMD5(pack.packageId)"
                                  v-else
                                >
                                  [{{ checksums[pack.packageId] }}]
                                </a>
                              </small>
                            </div>
                            <p class="mb-1">{{ pack.description }}</p>
                            <small class="float-right " style="color:green"
                              >Available</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="list-group-item  list-group-item-action  flex-column align-items-start"
                      style="border-top: 1px solid lightgray"
                      v-for="pack in getPendingPackages()"
                      :key="pack.packageId"
                    >
                      <div class="row no-gutters">
                        <div class="col-auto">
                          <img
                            :src="'/thumbnails/' + pack.packageId + '.png'"
                            class="img-fluid"
                            style="height:100px"
                            alt=""
                          />
                        </div>
                        <div class="col">
                          <div class=" px-2">
                            <div class="d-flex w-100 justify-content-between">
                              <h5 class="mb-1 ">
                                <a
                                  href="#"
                                  class="text-warning"
                                  style="color:green"
                                  >{{ pack.downloadTitle }}</a
                                >
                              </h5>
                              <small class="text-muted">{{ pack.size }}</small>
                            </div>
                            <p class="mb-1">{{ pack.description }}</p>
                            <small class="text-warning float-right"
                              >Pending</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="hasNotAvailablePackages()">
                    <h3 class="text-black mt-0 mt-4">
                      Additional packages available upon request
                    </h3>

                    <!--                    <hr class="divider dark my-4" />-->
                    <div class="mt-0 mb-4">
                      <button
                        type="button"
                        class="m-auto btn btn-primary d-block"
                        style=""
                        @click="showModelForPackage"
                      >
                        <i class="fas fa-user-shield"></i> Request Access
                      </button>
                    </div>
                    <div
                      class="list-group text-left"
                      v-for="pack in getNotAvailablePackages()"
                      :key="pack.id"
                    >
                      <div
                        class="list-group-item flex-column align-items-start "
                        style="opacity:50"
                      >
                        <div class="row no-gutters">
                          <div class="col-auto">
                            <img
                              :src="'/thumbnails/' + pack.packageId + '.png'"
                              class="img-fluid"
                              style="height:100px"
                              alt=""
                            />
                          </div>
                          <div class="col">
                            <div class=" px-2">
                              <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-1 ">
                                  <a href="#" class="text-body">{{
                                    pack.downloadTitle
                                  }}</a>
                                </h5>
                                <small class="text-muted">{{
                                  pack.size
                                }}</small>
                              </div>
                              <p class="mb-1">{{ pack.description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>

    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Request Access</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" @click="showModal = false"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label for="exampleFormControlTextarea1">Reason</label>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      v-model="requestReason"
                    ></textarea>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="showModal = false"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="requestPackagePressed"
                  >
                    Submit Request
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

  <v-dialog
      v-model="contractDialog"
      width="600px"
    >

      <v-card height="50vh" style="overflow:auto">
        <v-card-title>License Agreement</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
<!-- Created using word to HTML converter  UGLY -->
            <p style='margin:0cm;text-align:center;font-size:13px;font-family:"Courier New";font-weight:bold;text-decoration:underline;'><span style='font-size:16px;font-family:"Calibri",sans-serif;'>License agreement&nbsp;</span></p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:center;'><strong>&nbsp;</strong></p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:center;'><strong>(&ldquo;this Agreement&rdquo;)</strong></p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>This Agreement is entered into between:</p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>a. ETH Zurich ([Company Number])&nbsp;a&nbsp;university&nbsp;organised under Swiss public law, having its registered office at, R&auml;mistrasse 101, 8092 Zurich, Switzerland&nbsp;(&ldquo;ETH&rdquo;); and</p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>b. The individual who has been granted a license under this Agreement (the &ldquo;Licensee&rdquo;).</p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;'><strong>It is hereby agreed:</strong></p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>&nbsp;</p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>ETH has developed, in the context of a research and development activity with its business partners at considerable expense and effort, a collection of streel-level images or sequences of images formatted for the purpose of research in the field of computer vision and machine learning algorithms (the &quot;Dataset&quot;). ETH is willing to license to Licensee the use of this Dataset (&ldquo;License&rdquo;) provided the Dataset is obtained directly from ETH, and provided Licensee accepts all terms and conditions contained in this License. The term &quot;you&quot; and &quot;your&quot; means the Licensee using the Dataset.&nbsp;</p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><strong><u>1. Research Use License Grant</u></strong></p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>1.1 The Dataset is made freely available to academic and non-academic entities for non-commercial purposes only (such as academic research, teaching, scientific publications, or personal experimentation) (the &ldquo;Research Purpose&rdquo;).</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>1.2 Subject to and conditional upon your compliance with the obligations included in this Agreement, ETH grants to you a worldwide, royalty-free, non-sublicensable, non-transferable, and non-exclusive copyright license, solely in furtherance your Research Purpose, to download, reproduce and use the Dataset.</p>
            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><strong>2. License Permission&nbsp;</strong></p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>Permission to use the Dataset is granted to you under the following conditions:</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>2.1 the Dataset comes &quot;AS IS&quot;, without express or implied warranty. Although every effort has been made to ensure accuracy, ETH does not accept any responsibility for errors or omissions.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>2.2 you agree to include a reference to the Dataset in any work that makes use of the Dataset. For research papers, you shall cite our relevant publications as listed on our website; for other media, you shall cite our relevant publications as listed on our website or include a link to our website.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>2.3 you agree not to share or distribute the Dataset or modified versions of it. It is permissible to distribute derivative works in as far as they are abstract representations of the Dataset (such as models trained on it or additional annotations that do not directly include any of our data) and do not allow to recover the dataset or something similar in character.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>2.4 you shall not use the Dataset or any derivative work for commercial purposes as, for example, licensing or selling the data, or using the Dataset with a purpose to procure a commercial gain.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>2.5 all rights not expressly granted to you are reserved by ETH.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><strong>3. Privacy.</strong>&nbsp;</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>The Licensee further agrees to the following terms:</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>3.1 to comply with the EU General Data Protection Regulation 2016/679 of 27 April 2016 (&ldquo;GDPR&rdquo;), and any other relevant legislation in the European Economic Area (EEA) and Switzerland (hereinafter referred to as &ldquo;Data Protection Law&rdquo;).</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>3.2 to implement appropriate technical and organization measures required under the Data Protection Law in order to ensure a sufficient level of security for the storage and processing of the Dataset.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>3.3 not to use and share the Dataset in any work such as research publication, unless it has effectively anonymized the Dataset in such a way that individuals and vehicles can no longer be identified in accordance with Data Protection Law.&nbsp;</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><strong>4. Liability</strong></p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>4.1 ETH and its business partners will not be held liable for any direct, indirect, incidental, special, consequential or exemplary damages, or cost of procurement of substitute services, or damages for loss of revenue, profits, goodwill, use, data or other intangible losses (even if ETH has been advised of the possibility of such damages), resulting from the use of or inability to use the Dataset or the exercise of the licensed rights granted hereunder.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>4.2 Any use of the License in a manner not expressly authorized by this Agreement or in breach of this Agreement constitutes an infringement, entitling ETH to exercise all rights and remedies available under the applicable laws as defined in section 6 of this Agreement.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>4.3 The Licensee shall indemnify ETH in respect of all costs, claims, losses, expenses or damage arising as a result of the Licensee failing to comply with their obligations under this Agreement.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><strong>5. Assignment.&nbsp;</strong></p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>The License shall not be assigned or transferred, nor its rights or obligations, by Licensee without the prior and express written consent of ETH. Any assignment made in violation of this section will be void. ETH may freely assign this License without the necessity for consent.</p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><strong>6. Governing Law.&nbsp;</strong></p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>This License Agreement will be governed by and construed under the laws of Switzerland. Any disputes arising from this Agreement or its enforceability shall be settled by <span style="background:yellow;">[please complete].</span></p>
            <p style='margin-top:12.0pt;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>By clicking on &quot;I agree to the terms of this License&quot; you demonstrate acceptance to this License Agreement, and thereby you accept becoming legally bound by it, including the company or other legal entity represented by you or on whose behalf you act.</p>

        </v-card-text>
        <div style = "padding-left:10px">
          <v-checkbox
            v-model="licenseAgreed"
            dense
            class="license-agreed">

            <template v-slot:label>
              <div style="padding-top: 6px">
                I agree to the terms of this License
              </div>
            </template>
          </v-checkbox>
        </div>

        <v-card-actions>

        <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            outlined
            :disabled="!licenseAgreed"
            @click="acceptContract()"
          >
            Download
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>




</template>

<script>
import { mapActions, mapState } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  name: "DownloadPage",
  components: { NavigationMain },

  data() {
    return {
      requestReason: "",
      showModal: false,
      packages: [],
      selectedPackage: {},
      checksums: {},
      contractDialog: false,
      licenseAgreed: false
    };
  },
  computed: {
    ...mapState("api", ["status", "user"])
  },

  methods: {
    ...mapActions("api", [
      "getPackagesForUser",
      "handleRequestError",
      "requestPackage",
      "requestRole",
      "getMD5ForPackage",
      "agreeToContract"
    ]),
    ...mapActions("filehandlingManager", ["download"]),
    removeMD5(id) {
      this.checksums[id] = undefined;
      this.checksums = Object.assign({}, this.checksums); // trigger change
    },
    loadMD5(id) {
      if (this.checksums[id]) return;
      this.checksums[id] = this.packages.filter(
        entry => entry.packageId === id
      )[0].md5;
      this.checksums = Object.assign({}, this.checksums); // trigger change
    },
    listAllPackages() {
      this.getPackagesForUser()
        .then(data => {
          this.packages = data.packages;
        })
        .catch(this.handleRequestError);
    },
    downloadDataset(id, name) {
      this.selectedPackage = this.packages.filter(
        entry => entry.packageId === id
      )[0];
      // Check if user has agreed to contract. If not show dialog
      if(this.selectedPackage.personalData && (!this.licenseAgreed ||  !this.contractDialog)) {
        this.licenseAgreed = false;
        this.contractDialog = true; // Show dialog
        return;
      }
      this.download({ file: id, name: name }).catch(this.handleRequestError);
    },
    getAvailablePackages() {
      return this.packages.filter(entry => entry.state === 0);
    },
    getPendingPackages() {
      return this.packages.filter(entry => entry.state === 1);
    },
    getNotAvailablePackages() {
      return this.packages.filter(entry => entry.state === 2);
    },
    showModelForPackage(packId) {
      if (packId) {
        this.selectedPackage = this.packages.filter(
          entry => entry.packageId === packId
        )[0];
      } else {
        this.selectedPackage = packId;
      }
      this.showModal = true;
    },
    hasNotAvailablePackages() {
      return this.packages.find(entry => entry.state == 2);
    },
    requestPackagePressed() {
      if (this.selectedPackage) {
        this.requestPackage({
          packageId: this.selectedPackage?.packageId,
          reason: this.requestReason
        })
          .then(() => {
            this.showModal = false;
            this.requestReason = "";
            this.packages.forEach(p => {
              if (p.packageId === this.selectedPackage.packageId) p.state = 1;
            });
          })
          .catch(this.handleRequestError);
      } else {
        this.requestRole({ role: "sensitive_data", reason: this.requestReason })
          .then(() => {
            this.showModal = false;
            this.requestReason = "";
            this.listAllPackages();
          })
          .catch(this.handleRequestError);
      }
    },
    acceptContract() {
      this.agreeToContract().then(res => {
        this.user.licenseAgreed = true;
        this.downloadDataset(this.selectedPackage.packageId, this.selectedPackage.downloadTitle);
        this.licenseAgreed = false;
        this.contractDialog = false;
      }).catch(this.handleRequestError);
    }
  },

  created() {
    this.listAllPackages();
  }
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

</style>
